import { InputGroup, NAME_REGEX } from "@funded-here-interface/common";
import { Checkbox, MantineProvider } from "@mantine/core";
import { FC } from "react";

interface IProps {
  authChecked: boolean;
  setAuthChecked: (value: boolean) => void;
  error?: { [key: string]: string }; // Updated to allow dynamic keys
  setMerchantFirstName: (value: string) => void;
  merchantFirstName: string;
  setMerchantLastName: (value: string) => void;
  merchantLastName: string;
  setMerchantTitle: (value: string) => void;
  merchantTitle: string;
}

const User: FC<IProps> = (props) => {
  const {
    authChecked,
    setAuthChecked,
    error,
    setMerchantFirstName,
    merchantFirstName,
    setMerchantLastName,
    merchantLastName,
    setMerchantTitle,
    merchantTitle,
  } = props;

  return (
    <>
      <MantineProvider theme={{ cursorType: "pointer" }}>
        <Checkbox
          style={{ marginBottom: "20px" }}
          checked={authChecked}
          labelPosition="left"
          label={
            <span style={{ fontWeight: "bold" }}>
              Will you be acting as an Authorized Representative?
            </span>
          }
          onChange={(event) => setAuthChecked(event.currentTarget.checked)}
        />
      </MantineProvider>
      <InputGroup
        isErrored={error?.merchantFirstName}
        onChange={(value: string) => {
          setMerchantFirstName(value.replace(NAME_REGEX, ""));
        }}
        labelText="Your first / given name (as shown in the national identification document)"
        id="firstName"
        value={merchantFirstName}
        errorMessage={!!error?.merchantFirstName}
      />
      <InputGroup
        isErrored={error?.merchantLastName}
        onChange={(value: string) => {
          setMerchantLastName(value.replace(NAME_REGEX, ""));
        }}
        labelText="Your last name (as shown in the national identification document)"
        id="lastName"
        value={merchantLastName}
        errorMessage={!!error?.merchantLastName}
      />
      <InputGroup
        isErrored={error?.merchantTitle}
        onChange={(value: string) => {
          setMerchantTitle(value.replace(NAME_REGEX, ""));
        }}
        labelText="Your role in the company"
        id="merchantTitle"
        value={merchantTitle}
        errorMessage={!!error?.merchantTitle}
      />
    </>
  );
};

export default User;
